<template>
  <PrescriptionInfoPage :config="config" />
</template>

<script>
import PrescriptionInfoPage from '@/components/smallComponents/PrescriptionInfoPage.vue'

export default {
  components: { PrescriptionInfoPage },
  data() {
    return {
      config: {
        pageTitle: '调理信息',
        useInfoTitle: '使用信息',
        showSymptoms: true,
        submitRouteMode1: '/chaoweiPrescriptionResult',
        btnTextMode1: '提交信息',
        showGanZhiLabel: true,
        supportMode: false,
      },
    }
  },
}
</script>
<style scoped>
</style>
